import React from "react";
import "./appBar.css";
import { WirderMark } from "./wirderMark";
import { ChevronLeft, Close } from "./icons";

export interface AppBarProps {
  /** Show a back/close button on the left. */
  onBack?: () => void;
  backIcon?: "chevron" | "close";
  backLabel?: string;
  /** Brand mode: logo + "Wirder" wordmark on the left. */
  brand?: boolean;
  /** Page mode: centered title. */
  title?: string;
  /** Optional right-side action (e.g. a Share button or icon button). */
  right?: React.ReactNode;
}

export function AppBar({
  onBack,
  backIcon = "chevron",
  backLabel = "Back",
  brand,
  title,
  right,
}: AppBarProps) {
  const hasLeftButton = !!onBack;
  return (
    <div className="appbar">
      {onBack && (
        <button className="appbar__back" aria-label={backLabel} onClick={onBack}>
          {backIcon === "close" ? <Close /> : <ChevronLeft />}
        </button>
      )}

      {brand && (
        <>
          <WirderMark className="appbar__logo" />
          <span className="appbar__word">Wirder</span>
        </>
      )}

      {title ? <span className="appbar__title">{title}</span> : <span className="appbar__spacer" />}

      {right ? right : (hasLeftButton || title) && <span className="appbar__rightspacer" />}
    </div>
  );
}
